import ScoreSetting from "./KrScoreSetting.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrScoreSetting = install(ScoreSetting); // 生成带有 install 方法的组件

export default KrScoreSetting;
